export const reportError = error => {
  window.alert(error)
}
